function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "credit-card-refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.5 10H2.5M11.5 19L19.3 19C20.4201 19 20.9802 19 21.408 18.782C21.7843 18.5903 22.0903 18.2843 22.282 17.908C22.5 17.4802 22.5 16.9201 22.5 15.8V8.2C22.5 7.0799 22.5 6.51984 22.282 6.09202C22.0903 5.7157 21.7843 5.40974 21.408 5.21799C20.9802 5 20.4201 5 19.3 5H17.5M11.5 19L13.5 21M11.5 19L13.5 17M7.5 19H5.7C4.57989 19 4.01984 19 3.59202 18.782C3.21569 18.5903 2.90973 18.2843 2.71799 17.908C2.5 17.4802 2.5 16.9201 2.5 15.8V8.2C2.5 7.0799 2.5 6.51984 2.71799 6.09202C2.90973 5.71569 3.2157 5.40973 3.59202 5.21799C4.01984 5 4.5799 5 5.7 5H13.5M13.5 5L11.5 7M13.5 5L11.5 3",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardRefresh);
export default __webpack_public_path__ + "static/media/credit-card-refresh.148fc992e3ddabee6d09f5380b7ddca9.svg";
export { ForwardRef as ReactComponent };